import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';

export const TopLevelAnalysisInputs = z.object({
  dropdowns: EmptyObject,
  extras: EmptyObject,
});

export type TopLevelAnalysisInputs = z.infer<typeof TopLevelAnalysisInputs>;

export const TopLevelAnalysisRequest = createCustomVizRequestSchema(
  'topLevelAnalysis',
  TopLevelAnalysisInputs,
);

export type TopLevelAnalysisRequest = z.infer<typeof TopLevelAnalysisRequest>;
